import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * HighlightPipe
 *
 * Transforms a text string by wrapping occurrences of the search query
 * with a styled <span> tag (color: #00A0DF, bold) to visually highlight matches.
 *
 * Usage: {{ item.title | highlight: searchQuery }}
 *        <span [innerHTML]="item.title | highlight: searchQuery"></span>
 *
 * - Highlighting is skipped if the search query is fewer than 3 characters.
 * - Matching is case-insensitive.
 * - Special regex characters in the query are safely escaped.
 * - Output is sanitized via DomSanitizer to allow safe HTML binding.
 */
@Pipe({
  name: 'highlight',
  standalone: true,
})
export class HighlightPipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  transform(text: string, search: string): SafeHtml {
    if (!search || search.trim().length <= 2) {
      return text;
    }

    const escaped = search.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    const highlighted = text.replace(
      regex,
      `<span style="color: #00A0DF; font-weight: bold;">$1</span>`
    );
    return this._sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}